/* ===== Cenzio — ulke secici bayraklari =====
   Dawn'in localization formuna dokunmuyoruz (POST /localization oldugu
   gibi kaliyor); sadece butona ve her satira bayrak dugumu ekliyoruz.
   Bayraklar emoji degil inline SVG: emoji bayraklar Windows'ta harf
   kodu olarak gorunur ve premium hissi bozardi.
   ============================================================ */
(function () {
  'use strict';

  var VB = '0 0 22 15';

  /* Ucte bir dikey seritli bayraklar icin kisayol */
  function vert(a, b, c) {
    return '<rect width="22" height="15" fill="' + b + '"/>' +
           '<rect width="7.34" height="15" fill="' + a + '"/>' +
           '<rect x="14.66" width="7.34" height="15" fill="' + c + '"/>';
  }
  /* Ucte bir yatay seritli bayraklar icin kisayol */
  function horiz(a, b, c) {
    return '<rect width="22" height="15" fill="' + b + '"/>' +
           '<rect width="22" height="5" fill="' + a + '"/>' +
           '<rect y="10" width="22" height="5" fill="' + c + '"/>';
  }

  var FLAGS = {
    US:
      '<rect width="22" height="15" fill="#fff"/>' +
      '<g fill="#b22234">' +
      '<rect y="0" width="22" height="1.154"/><rect y="2.308" width="22" height="1.154"/>' +
      '<rect y="4.615" width="22" height="1.154"/><rect y="6.923" width="22" height="1.154"/>' +
      '<rect y="9.231" width="22" height="1.154"/><rect y="11.538" width="22" height="1.154"/>' +
      '<rect y="13.846" width="22" height="1.154"/></g>' +
      '<rect width="9.4" height="8.08" fill="#3c3b6e"/>' +
      '<g fill="#fff">' +
      '<circle cx="1.6" cy="1.3" r="0.34"/><circle cx="4.1" cy="1.3" r="0.34"/><circle cx="6.6" cy="1.3" r="0.34"/>' +
      '<circle cx="2.85" cy="2.7" r="0.34"/><circle cx="5.35" cy="2.7" r="0.34"/><circle cx="7.85" cy="2.7" r="0.34"/>' +
      '<circle cx="1.6" cy="4.1" r="0.34"/><circle cx="4.1" cy="4.1" r="0.34"/><circle cx="6.6" cy="4.1" r="0.34"/>' +
      '<circle cx="2.85" cy="5.5" r="0.34"/><circle cx="5.35" cy="5.5" r="0.34"/><circle cx="7.85" cy="5.5" r="0.34"/>' +
      '<circle cx="1.6" cy="6.9" r="0.34"/><circle cx="4.1" cy="6.9" r="0.34"/><circle cx="6.6" cy="6.9" r="0.34"/>' +
      '</g>',
    CA:
      '<rect width="22" height="15" fill="#fff"/>' +
      '<rect width="5.5" height="15" fill="#d52b1e"/>' +
      '<rect x="16.5" width="5.5" height="15" fill="#d52b1e"/>' +
      '<path fill="#d52b1e" d="M11 3.1l.63 1.72 1.63-.45-.45 1.55 1.45.36-1.18 1.09.36.82-1.81-.27.18 2-.81-.73-.81.73.18-2-1.81.27.36-.82L7.72 6.28l1.45-.36-.45-1.55 1.63.45z"/>' +
      '<rect x="10.8" y="9.4" width="0.4" height="1.9" fill="#d52b1e"/>',
    AU:
      '<rect width="22" height="15" fill="#00247d"/>' +
      '<g stroke="#fff" stroke-width="1.5"><path d="M0 0l11 7.5M11 0L0 7.5"/></g>' +
      '<g stroke="#cf142b" stroke-width="0.7"><path d="M0 0l11 7.5M11 0L0 7.5"/></g>' +
      '<path stroke="#fff" stroke-width="2.6" d="M5.5 0v7.5M0 3.75h11"/>' +
      '<path stroke="#cf142b" stroke-width="1.4" d="M5.5 0v7.5M0 3.75h11"/>' +
      '<g fill="#fff">' +
      '<circle cx="5.5" cy="11.2" r="1.15"/>' +
      '<circle cx="16.1" cy="2.6" r="0.62"/><circle cx="18.6" cy="5.6" r="0.62"/>' +
      '<circle cx="16.1" cy="8.9" r="0.62"/><circle cx="13.9" cy="5.9" r="0.52"/>' +
      '<circle cx="16.1" cy="5.6" r="0.36"/></g>',
    CH:
      '<rect width="22" height="15" fill="#d52b1e"/>' +
      '<rect x="9.4" y="3" width="3.2" height="9" fill="#fff"/>' +
      '<rect x="6.4" y="6" width="9.2" height="3" fill="#fff"/>',
    NO:
      '<rect width="22" height="15" fill="#ba0c2f"/>' +
      '<path stroke="#fff" stroke-width="4" d="M7.5 0v15M0 7.5h22"/>' +
      '<path stroke="#00205b" stroke-width="2" d="M7.5 0v15M0 7.5h22"/>',
    GB:
      '<rect width="22" height="15" fill="#00247d"/>' +
      '<g stroke="#fff" stroke-width="3"><path d="M0 0l22 15M22 0L0 15"/></g>' +
      '<g stroke="#cf142b" stroke-width="1.6"><path d="M0 0l22 15M22 0L0 15"/></g>' +
      '<path stroke="#fff" stroke-width="5" d="M11 0v15M0 7.5h22"/>' +
      '<path stroke="#cf142b" stroke-width="3" d="M11 0v15M0 7.5h22"/>',
    IE: vert('#169b62', '#ffffff', '#ff883e'),
    FR: vert('#002395', '#ffffff', '#ed2939'),
    IT: vert('#009246', '#ffffff', '#ce2b37'),
    BE: vert('#000000', '#fae042', '#ed2939'),
    NL: horiz('#ae1c28', '#ffffff', '#21468b'),
    DE: horiz('#000000', '#dd0000', '#ffce00'),
    AT:
      '<rect width="22" height="15" fill="#ed2939"/>' +
      '<rect y="5" width="22" height="5" fill="#fff"/>',
    ES:
      '<rect width="22" height="15" fill="#aa151b"/>' +
      '<rect y="3.75" width="22" height="7.5" fill="#f1bf00"/>'
  };

  function makeFlag(code) {
    var art = FLAGS[code];
    if (!art) return null;
    var svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    svg.setAttribute('viewBox', VB);
    svg.setAttribute('class', 'cz-flag');
    svg.setAttribute('aria-hidden', 'true');
    svg.innerHTML = art;
    return svg;
  }

  /* Panel satirlari: her <a data-value="XX"> icin bayrak */
  function decorateList(root) {
    (root || document).querySelectorAll('.disclosure__link[data-value]').forEach(function (a) {
      if (a.querySelector('.cz-flag')) return;
      var f = makeFlag(a.getAttribute('data-value'));
      if (!f) return;
      a.insertBefore(f, a.firstChild);
      a.classList.add('cz-loc__row');
    });
  }

  /* Acilis butonu: secili ulkenin bayragi */
  function currentCode() {
    var active = document.querySelector('.disclosure__link[aria-current], .disclosure__link--active');
    if (active && active.getAttribute('data-value')) return active.getAttribute('data-value');
    if (window.Shopify && window.Shopify.country) return window.Shopify.country;
    return null;
  }

  function decorateButton(root) {
    (root || document).querySelectorAll('.localization-form__select').forEach(function (b) {
      if (b.querySelector('.cz-flag')) return;
      var f = makeFlag(currentCode());
      if (!f) return;
      b.insertBefore(f, b.firstChild);
      b.classList.add('cz-loc__btn');
    });
  }

  function apply() { decorateList(); decorateButton(); }

  function init() {
    apply();
    if (!('MutationObserver' in window)) return;
    var t = null;
    new MutationObserver(function () {
      clearTimeout(t);
      t = setTimeout(apply, 80);
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }
})();
